import React, { useContext } from "react";

import { Permissions } from "@/lib/permissions";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";

import UserContext from "@/components/UserContext/UserContext";

import modelPOI from "@/models/poi";
import modelComments from "@/models/komentari";

import POIDialog from "@/views/GIS/POIPage/POIDialog";
import CommentDialog from "@/views/Komentari/CommentDialog";


import { OwnerOrganisations } from "@/lib/ownerOrganisations";
import { DCRecord } from "@/@types/lib/dataController";

function POIPage() {
  const userContext = useContext(UserContext);

  const definePOIForm = (record: DCRecord) => {

    const recordOwnerId = record.owner_organisation as number; // 20 za hgss, 30 za hps

    if (userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HGSSRead])) {
      if (recordOwnerId === OwnerOrganisations.HGSS.code) {
        return "hgss_user_on_hgss_data"
      }
      if (recordOwnerId === OwnerOrganisations.HPS.code) {
        return "hgss_user_on_hps_data"
      }
      
      console.warn("how did u get here? 1")
      return "edit"
    }
    
    if (userContext?.hasAnyPermission([Permissions.HPSMod, Permissions.HPSRead])) {
      if (recordOwnerId === OwnerOrganisations.HGSS.code) {
        return "hps_user_on_hgss_data"
      }
      if (recordOwnerId === OwnerOrganisations.HPS.code) {
        return "hps_user_on_hps_data"
      }

      console.warn("how did u get here? 2")
      return "edit"
    }

    console.log("how did u get here? 3")
    return "edit"
  };

  const komentriForm = userContext?.hasAnyPermission([Permissions.HGSSMod]) ? "update-hgss"
  : userContext?.hasAnyPermission([Permissions.HPSMod]) ? "update-hps" 
  : "default";

  const allowAdd = userContext?.hasAnyPermission([Permissions.HGSSMod]);
  const allowView = userContext?.hasAnyPermission([Permissions.HGSSRead, Permissions.HPSRead]);
  const allowEdit = userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod]);

  const hasAdminRights = userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod]);

  return (
    <DataCentricPage
      needPermission={[Permissions.HGSSRead, Permissions.HPSRead, Permissions.HPSSharedView]}

      primaryModel={modelPOI}
      primaryTitleToken="titles.poi"
      primaryView="default"
      primaryAllowAdd={allowAdd}
      primaryAllowView={allowView}
      primaryAllowEdit={allowEdit}
      primaryDialogComponent={POIDialog}
      primaryDialogForm={definePOIForm}
      primaryDialogAsPagePath={userContext?.getDefaultUrl() + '/poi/'}

      secondaryModel={modelComments}
      secondaryTitleToken={hasAdminRights ? "titles.komentari" : "titles.komentari_moji"}
      secondaryView={hasAdminRights ? "related_komentari" : "my_related_komentari"}
      secondaryAllowView={allowView}
      secondaryAllowEdit={allowEdit}
      secondaryDialogComponent={CommentDialog}
      secondaryDialogForm={komentriForm}

      baseRecordPath={modelPOI.apiPath}
      childRecordRelativePath="komentari"
      geomRelativePath=""

      mapId={6}
      mapModel={modelPOI}
    />
  );
}

export default POIPage;
